import { render, staticRenderFns } from "./TNav.vue?vue&type=template&id=ef04054e&scoped=true&"
import script from "./TNav.vue?vue&type=script&lang=js&"
export * from "./TNav.vue?vue&type=script&lang=js&"
import style0 from "./TNav.vue?vue&type=style&index=0&id=ef04054e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef04054e",
  null
  
)

/* custom blocks */
import block0 from "./TNav.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports